import { STORAGE_KEYS } from '@nvision/oidc';
import { useEffect, useRef } from 'react';
import { checkIdentityLogin } from '../utils';
import { useIdentityAuth } from './use-auth';

export const useRequireAuth = () => {
  const auth = useIdentityAuth();
  const isProcessed = useRef(false);
  const { isIdentityLogin } = checkIdentityLogin();

  useEffect(() => {
    if (!isProcessed.current && isIdentityLogin && !auth.isLoading && !auth.isAuthenticated) {
      isProcessed.current = true;
      // Store the current path before redirect
      sessionStorage.setItem(STORAGE_KEYS.redirectURL, window.location.href);
      // Initiate the signin process
      auth.signinRedirect();
    }
  }, [auth.isLoading, auth.isAuthenticated]);

  return auth;
};
